<template>
  <b-card>
    <template v-if="changeView == 0">
      <div slot="header">
        <b-row align-v="center">
          <b-col cols="2" sm="3" md="4" lg="4" xl="5"></b-col>
          <b-col cols="9" sm="7" md="6" lg="6" xl="5">
            <h3>Lista de clientes</h3>
          </b-col>
        </b-row>
      </div>
      <div>
        <b-container fluid>
          <b-row>
            <b-col cols="12" sm="10" md="10" lg="10" xl="2">
              <b-form-group horizontal label="Orden" class="mb-0">
                <b-input-group>
                  <b-form-select v-model="orden" slot="append" @input="listTerceros">
                    <option :value="'asc'">Más Antiguo</option>
                    <option :value="'desc'">Más Reciente</option>
                  </b-form-select>
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col cols="12" sm="10" md="10" lg="10" xl="2">
              <b-form-group horizontal label="Mostrar" class="mb-0">
                <b-input-group>
                  <b-form-select v-model="limite" slot="append">
                    <option :value="10">10</option>
                    <option :value="25">25</option>
                    <option :value="50">50</option>
                    <option :value="100">100</option>
                  </b-form-select>
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col cols="12" sm="10" md="10" lg="10" xl="2">
              <div class="col-md-12 text-center">
                <b-button variant="secondary" @click="listTerceros">
                  <i class="fa fa-sync-alt"></i>
                </b-button>
              </div>
            </b-col>
            <b-col cols="12" sm="10" md="10" lg="10" xl="4">
              <b-form-group horizontal label="Filtrar por campo" class="mb-0">
                <b-input-group>
                  <b-form-input v-model="filter" placeholder="Ingresa parametro de busqueda" />
                  <b-input-group-append>
                    <b-btn :disabled="!filter" @click="filter = ''">Limpiar</b-btn>
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col cols="1" sm="2" md="2" lg="2" xl="2">
              <b-button v-b-modal.newclient1 variant="primary" @click="newClient()">
                <i class="fa fa-plus"></i> Nuevo Cliente
              </b-button>
            </b-col>
          </b-row>
          <br />
          <br />
          <b-table
            responsive
            :busy="isBusy2"
            small
            outlined
            striped
            :items="customers"
            :fields="customers_fields"
            :current-page="pactual"
            :filter="filter"
            :per-page="limite"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            :sort-direction="sortDirection"
            @filtered="onFiltered"
          >
            <div slot="table-busy" class="text-center text-danger my-2">
              <b-spinner class="align-middle"></b-spinner>
              <strong>Cargando...</strong>
            </div>
            <template slot="razonSocial" slot-scope="row">
              <b-link
                @click="addContact(row.item)"
                class="stylerazonsocial"
              >{{ row.item.razonSocial }}</b-link>
            </template>
            <template slot="correos" slot-scope="row">
              <h5>
                <b-badge
                  v-for="(item, index) in row.item.emailEnvio"
                  :key="index"
                  pill
                  variant="secondary"
                  class="mr-2"
                >{{item}}</b-badge>
              </h5>
            </template>
            <template slot="red" slot-scope="row">
              <i v-if="row.item.asociado == 1" class="fa fa-globe colorred"></i>
              <i v-else class="fa fa-globe text-secondary"></i>
            </template>
            <template slot="acciones" slot-scope="row">
              <b-button-group>
                <!-- <b-button
                  v-b-modal.newclient1
                  v-b-tooltip.hover
                  variant="primary"
                  @click="editClient(row.item)"
                >
                  <i class="fa fa-pencil-alt" title="Editar Cliente"></i>
                </b-button> -->
                <!-- <b-button
                  v-b-modal.newdirection1
                  v-b-tooltip.hover
                  variant="primary"
                  @click="listDirection(row.item, 1)"
                >
                  <i class="fa fa-map-marked-alt" title="Agregar Direcciones"></i>
                </b-button> -->
                <!-- <b-button v-b-tooltip.hover variant="primary" @click="addContact(row.item)">
                  <i class="fa fa-users" title="Agregar Contacto"></i>
                </b-button> -->
                <b-button size="sm" @click="deleteClient(row.item)" v-b-tooltip.hover variant="danger">
                  <i class="fa fa-trash" title="Eliminar Cliente"></i>
                </b-button>
              </b-button-group>
            </template>
          </b-table>
        </b-container>
        <b-row>
          <b-col cols="3">
            <p>Mostrando del {{desde}} al {{hasta}} de un total de {{total}} registros 
              <b-button  
              style="border:none" 
              variant="outline-success" 
              href="http://telemovildata.com/producto/modelo_de_excel_para_registrar_negocios.xlsx" 
              
              v-b-tooltip.hover title="Ejemplo de Excel para importar lista de contactos a Negocios de manera masiva">
              <i class="fa fa-2x fa-solid fa-file-excel"></i>
              </b-button>
            </p>
          </b-col>
          <b-col cols="1">
            <div style="width:115%;">
              <b-button class="float-right" v-if="file1 !=null" variant="ligth" @click="eliminarFile()">
                <i class="far fa-trash-alt text-danger"></i>
              </b-button>
            </div>
          </b-col>
          <b-col cols="3">
            <b-form-file v-model="file1" placeholder="Elija un archivo" drop-placeholder="Suelta el archivo aquí..."></b-form-file>          
          </b-col>
          <b-col cols="2">
            <div v-if="file1 == null">
              <b-button title="Sin documento" disabled><i class="fa fa-upload"></i></b-button>
            </div>
            <div v-else>
              <b-button title="Subir Documento" variant="success" @click="importarTerceros()"><i class="fa fa-upload"></i></b-button>
            </div>
          </b-col>
          <b-col cols="2">
              <b-pagination
                size="sm"
                :total-rows="customers.length"
                v-model="pactual"
                :per-page="limite"
              ></b-pagination>  
          </b-col>
        </b-row>
        <vue-snotify></vue-snotify>
        <b-modal id="newclient1" :title="titlecliente" v-model="nuevocliente" size="xl">
          <div role="group" v-if="cargandoDataUpdate">
            <b-row>
              <b-col cols="12" sm="6" md="4" lg="3" xl="4">
                <select
                  class="custom-select"
                  id="inlineFormCustomSelect"
                  v-model="tipoDocumento"
                  :disabled="update"
                >
                  <option
                    :value="tipodocumento.tipo"
                    v-for="tipodocumento in documentosIdentidad"
                    v-bind:key="tipodocumento.tipo"
                  >{{ tipodocumento.nombre }}</option>
                </select>
              </b-col>
              <b-col v-if="!updateClienteDatos" cols="6" sm="6" md="6" lg="6" xl="4">
                <b-input-group v-if="sindoc">
                  <b-form-input placeholder="Documento" v-model="receptor.ruc" :disabled="true"></b-form-input>
                </b-input-group>
                <b-input-group v-else>
                  <b-form-input
                    placeholder="Documento"
                    v-model="receptor.ruc"
                    :disabled="update"
                    @keyup.enter="getTercero()"
                  ></b-form-input>
                </b-input-group>
                <template v-if="cargandoreceptor">
                  <b-list-group class="searcher-field">
                    <b-list-group-item>
                      Buscando
                      <i class="fa fa-spin fa-spinner"></i>
                    </b-list-group-item>
                  </b-list-group>
                </template>
                <b-list-group v-if="listarec" class="searcher-field">
                  <!-- <b-list-group-item v-if="norec">No hay Receptores con ese número</b-list-group-item> -->
                  <template v-for="(item, index) in listaTerceros" class="buscarRuc">
                    <b-list-group-item
                      :key="index"
                      @click="setReceiver(item)"
                      class="searcher-result"
                    >{{item.idReceptor + ' - ' + item.razonSocial}}</b-list-group-item>
                  </template>
                </b-list-group>
              </b-col>
              <b-col v-else cols="6" sm="6" md="6" lg="6" xl="4">
                <h6>
                  <i class="fa fa-spin fa-spinner"></i> Cargando
                </h6>
              </b-col>
              <b-col cols="6" sm="6" md="6" lg="6" xl="4">
                <b-input-group size="sm" class="styleruc" v-if="!update">
                  <i>Puede hacer busquedas por RUC, solo ingreselo y presione ENTER</i>
                </b-input-group>
              </b-col>
            </b-row>
            <br />
            <b-row>
              <b-col sm="5">
                <b-input-group>
                  <b-form-input placeholder="Nombre o Razon Social" v-model="receptor.razonSocial"></b-form-input>
                </b-input-group>
              </b-col>

              <b-col sm="7">
                <b-input-group>
                  <b-form-input maxlength="100" placeholder="Direccion referencia" v-model="receptor.direccion"></b-form-input>
                </b-input-group>
              </b-col>
            </b-row>
            <br />
            <b-row>
              <b-col sm="3">
                <b-input-group>
                  <b-form-input placeholder="Celular" v-model="celular"></b-form-input>
                </b-input-group>
              </b-col>
              <b-col sm="3">
                <b-input-group>
                  <b-form-input placeholder="Teléfono" v-model="telefono"></b-form-input>
                </b-input-group>
              </b-col>
              <b-col sm="6">
                <b-form-group
                  label-for="input_correo"
                  :invalid-feedback="invalidFeedbackCorreo"
                  :valid-feedback="validFeedbackCorreo"
                  :state="stateCorreo"
                  description="Ingrese un correo y pulse ENTER, para agregarlo a la lista."
                >
                  <b-form-input
                    :disabled="sindoc"
                    class="input-dark"
                    type="email"
                    v-model="correo"
                    required
                    @keyup.enter="addCorreo()"
                    :state="stateCorreo"
                    placeholder="Correos para facturación"
                  ></b-form-input>
                </b-form-group>
              </b-col>
              <b-col sm="3">
                <select class="custom-select" v-model="tag1">
                    <option value=""> Ingrese Tag </option>
                  <option v-for="tag in listaTag" v-if="tag.numeroTag == 1" :key="tag.id" :value="tag.tag">{{ tag.tag }}</option>
                </select>
              </b-col>
              <b-col sm="3">
               <select class="custom-select" v-model="tag2">
                    <option value=""> Ingrese Tag </option>
                  <option v-for="tag in listaTag" v-if="tag.numeroTag == 2" :key="tag.id" :value="tag.tag">{{ tag.tag }}</option>
                </select>
              </b-col>
              
            </b-row>
            <b-row class="mt-4">
              <b-col cols="2" sm="3" md="4" lg="4" xl="4">
                <div class="lineaseparacion"></div>
              </b-col>
              <b-col cols="2" sm="3" md="4" lg="4" xl="4">
                <h6 class="centercorreo">Correos para Facturación</h6>
              </b-col>
              <b-col cols="2" sm="3" md="4" lg="4" xl="4">
                <div class="lineaseparacion"></div>
              </b-col>
            </b-row>
            <br />
            <b-row>
              <b-col cols="2" sm="3" md="4" lg="4" xl="12">
                <h5>
                  <b-badge
                    v-for="(item, index) in listaCorreos"
                    :key="index"
                    pill
                    variant="secondary"
                    @click="removeCorreo(index)"
                    class="mr-2"
                  >
                    {{item}}
                    <i class="fa fa-times borrarcorreo"></i>
                  </b-badge>
                </h5>
              </b-col>
            </b-row>
            <br />
            <b-row>
              <b-col cols="2" sm="3" md="4" lg="4" xl="12">
                <b-form-textarea
                  id="textarea"
                  v-model="observaciones"
                  placeholder="Observaciones..."
                  rows="3"
                  max-rows="6"
                ></b-form-textarea>
              </b-col>
            </b-row>
            <hr>
            <b-row>
              <b-col cols="2" sm="3" md="4" lg="4" xl="6">
                <b-form-textarea
                id="textarea"
                  v-model="observacionesPro"
                  placeholder="Observaciones Proforma..."
                  rows="3"
                  max-rows="6"
                ></b-form-textarea>
              </b-col>
              <b-col cols="2" sm="3" md="4" lg="4" xl="6">
                <b-form-textarea
                  v-model="observacionesNV"
                  placeholder="Observaciones Nota de Venta..."
                  rows="3"
                  max-rows="6"
                ></b-form-textarea>
              </b-col>
            </b-row>
          </div>
          <div v-else>
            <pulse-loader></pulse-loader>
          </div>
          <div slot="modal-footer" class="w-100">
            <template v-if="modalInsertUpdate === 1">
              <template v-if="validClient()">
                <template>
                  <b-btn
                    size="sm"
                    v-if="emitclient"
                    @click="addUpdateClient(1)"
                    class="float-right"
                    variant="primary"
                  >Guardar</b-btn>
                  <b-btn size="sm" v-else class="float-right" variant="secondary">
                    <i class="fa fa-spin fa-spinner"></i> Guardando ...
                  </b-btn>
                </template>
              </template>
              <template v-else>
                <div class="text-right">
                  <b-btn size="sm" class="btn btn-secondary" disabled>
                    <i class="fa fa-send"></i> Guardar
                  </b-btn>
                </div>
              </template>
            </template>
            <template v-else-if="modalInsertUpdate === 2">
              <template v-if="validClient()">
                <template>
                  <b-btn
                    size="sm"
                    v-if="editclient"
                    @click="addUpdateClient(2)"
                    class="float-right"
                    variant="warning"
                  >Actualizar</b-btn>
                  <b-btn size="sm" v-else class="float-right" variant="secondary">
                    <i class="fa fa-spin fa-spinner"></i> Actualizando ...
                  </b-btn>
                </template>
              </template>
              <template v-else>
                <div class="text-right">
                  <b-btn size="sm" class="btn btn-secondary" disabled>
                    <i class="fa fa-send"></i> Actualizar
                  </b-btn>
                </div>
              </template>
            </template>
          </div>
        </b-modal>
        <b-modal id="newdirection1" :title="titledirection" v-model="nuevaDireccion" size="lg">
          <div role="group">
            <b-row v-if="bloqueUbigeo">
              <b-col cols="2">
                <!-- @click="bloqueUbigeo=false" Falta agregar ese metodo cuando este operativo -->
                <b-btn>
                  <i class="fa fa-suitcase">Origen</i>
                </b-btn>
              </b-col>
              <b-col cols="2">
                <b-form-input
                  class="input-requerido"
                  type="text"
                  v-model="ubigeoPartida"
                  required
                  :placeholder="placeholderUbigeoPartida"
                ></b-form-input>
              </b-col>
              <b-col cols="8">
                <b-input-group size="md" :prepend="prependUbigeoOrigen">
                  <b-form-input
                    class="input-requerido"
                    type="text"
                    v-model="direccionTercero"
                    required
                    placeholder="Agregar Dirección"
                  ></b-form-input>
                </b-input-group>
              </b-col>
            </b-row>
            <b-row v-else>
              <b-col cols="3">
                <template>
                  <select
                    class="custom-select mr-sm-2"
                    v-model="departamentoSeleccionadoUbigeoOrigen"
                  >
                    <option
                      v-for="departamento in listDepartamento"
                      :value="departamento.codDepartamento"
                      :key="departamento.codDepartamento"
                    >{{ departamento.nombre }}</option>
                  </select>
                </template>
              </b-col>
              <b-col cols="3">
                <template>
                  <div v-if="!provOrigen">
                    <b-form-input type="text" disabled placeholder="Selecciona una Provincia..."></b-form-input>
                  </div>
                  <div v-else-if="provOrigenCargando">
                    <pulse-loader></pulse-loader>
                  </div>
                  <div v-else>
                    <select
                      class="custom-select mr-sm-2"
                      v-model="provinciaSeleccionadaUbigeoOrigen"
                    >
                      <option
                        v-for="provincia in listProvinceOrigen.Departments"
                        :value="provincia.codProvincia"
                        :key="provincia.codProvincia"
                      >{{ provincia.nombre }}</option>
                    </select>
                  </div>
                </template>
              </b-col>
              <b-col cols="3">
                <template>
                  <div v-if="!distOrigen">
                    <b-form-input type="text" disabled placeholder="Selecciona un Distrito..."></b-form-input>
                  </div>
                  <div v-else-if="distOrigenCargando">
                    <pulse-loader></pulse-loader>
                  </div>
                  <div v-else>
                    <select
                      class="custom-select mr-sm-2"
                      v-model="distritoSeleccionadoUbigeoOrigen"
                    >
                      <option
                        v-for="distrito in listDistrictOrigen.Departments"
                        :value="distrito"
                        :key="distrito.codDistrito"
                      >{{ distrito.nombre }}</option>
                    </select>
                  </div>
                </template>
              </b-col>
              <b-col cols="3">
                <b-btn @click="bloqueUbigeo=true" class="backubigeopartida">
                  <i class="fa fa-backward">Atras</i>
                </b-btn>
              </b-col>
            </b-row>
            <br />
            <b-row v-if="edicciondir">
              <b-col cols="12" sm="12" md="12" lg="12" xl="9"></b-col>
              <b-col cols="12" sm="12" md="12" lg="12" xl="3">
                <b-button
                  v-if="!editandodireccion"
                  class="buttoneditar"
                  variant="warning"
                  @click="editDireccion()"
                  title="Editar direccion"
                >
                  <i class="fa fa-pencil">Editar Direccion</i>
                </b-button>
                <b-button v-else type="button" variant="secondary">
                  <i class="fa fa-spin fa-spinner"></i> Editando...
                </b-button>
              </b-col>
            </b-row>
            <br />
            <b-row>
              <b-col cols="12" sm="12" md="12" lg="12" xl="12">
                <b-table
                  responsive
                  :busy="isBusy"
                  :small="small"
                  :outlined="outlined"
                  :striped="striped"
                  :items="directions"
                  :fields="directions_fields"
                  :current-page="pactual"
                  :per-page="limite"
                  :sort-by.sync="sortBy"
                  :sort-desc.sync="sortDesc"
                  :sort-direction="sortDirection"
                >
                  <div slot="table-busy" class="text-center text-danger my-2">
                    <b-spinner class="align-middle"></b-spinner>
                    <strong>Cargando...</strong>
                  </div>
                  <template slot="elegir" slot-scope="row">
                    <b-form-group>
                      <b-form-radio
                        v-model="selected"
                        :value="row.index"
                        @change="selectedDirection(row.item, row.index)"
                      ></b-form-radio>
                    </b-form-group>
                  </template>
                  <template slot="acciones" slot-scope="row">
                    <b-button
                      class="buttonaccion"
                      variant="primary"
                      @click="setValueDireccion(row.item)"
                      title="Editar direccion"
                    >
                      <i class="fa fa-pencil-alt"></i>
                    </b-button>
                    <b-button
                      class="buttonaccion"
                      variant="danger"
                      @click="preDeleteDireccion(row.item)"
                      title="Eliminar direccion"
                    >
                      <i class="fa fa-trash"></i>
                    </b-button>
                  </template>
                </b-table>
              </b-col>
            </b-row>
            <br />
          </div>
          <div slot="modal-footer" class="w-100">
            <template v-if="cambiarDireccion">
              <b-btn
                size="sm"
                class="float-right marginleft"
                variant="warning"
                @click="cambiarDireccionDefault()"
              >Cambiar Direccion Predeterminada</b-btn>
            </template>
            <template v-if="validarDireccion()">
              <template>
                <b-btn
                  size="sm"
                  v-if="verifydirection"
                  class="float-right"
                  variant="primary"
                  @click="addDirection()"
                >Guardar</b-btn>
                <b-btn size="sm" v-else class="float-right" variant="secondary">
                  <i class="fa fa-spin fa-spinner"></i> Guardando ...
                </b-btn>
              </template>
            </template>
            <template v-else>
              <div class="text-right">
                <b-btn size="sm" class="btn btn-secondary" disabled>
                  <i class="fa fa-send"></i> Guardar
                </b-btn>
              </div>
            </template>
          </div>
        </b-modal>
      </div>
    </template>
    <template v-else>
      <detalle-terceros
        v-if="changeView == 1"
        @tabindex="tabindex"
        :idCustomer="customerSelected"
        :customerData="dataCustomer"
      ></detalle-terceros>
    </template>
    <vue-snotify></vue-snotify>
  </b-card>
</template>

<script>
import axios from "axios";
import DetalleTerceros from "@/components/gestion/DetalleTerceros";
import { DocumentosIdentidadTerceros } from "@/shared/utils";
import { Departamentos } from "@/shared/utils";
import { PulseLoader } from "vue-spinner/dist/vue-spinner.min.js";
import { BLink } from "bootstrap-vue";
export default {
  name: "Terceros",
  components: {
    "detalle-terceros": DetalleTerceros,
    PulseLoader
  },
  data() {
    return {
      cargandoreceptor: false,
      sindoc: false,
      editandodireccion: false,
      edicciondir: false,
      submitted: false,
      isBusy2: false,
      editclient: true,
      cargandoDataUpdate: false,
      update: false,
      filter: null,
      rucCliente: "",
      changeView: 0,
      // cargando: false,
      customers: [],
      customers_fields: [
        { key: "red", label: "", sortable: true },
        { key: "documento", label: "Documento", sortable: true },
        { key: "razonSocial", label: "Razon Social", sortable: true },
        { key: "telefono", label: "Teléfono", sortable: true },
        { key: "movil1", label: "Celular", sortable: true },
        { key: "correos", label: "Correo para facturación", sortable: true },
        { key: "domFiscal", label: "Direccion por Defecto", sortable: true },
        { key: "tag1", label: "Tag 1", sortable: true },
        { key: "tag2", label: "Tag 2", sortable: true },
        { key: "acciones", label: "Acciones" }
      ],
      directions: [],
      directions_fields: [
        { key: "direccion", label: "Dirección", sortable: true },
        { key: "elegir", label: "Elegir" },
        { key: "acciones", label: "Acciones" }
      ],
      pactual: 1,
      emitclient: true,
      limite: 10,
      orden: "desc",
      striped: true,
      outlined: true,
      small: true,
      desde: "",
      hasta: "",
      total: "",
      titlecliente: "Registro de clientes",
      titledirection: "Agregar Direcciones",
      nuevocliente: false,
      sortBy: null,
      sortDesc: false,
      sortDirection: "asc",
      currentPage: 1,
      totalRows: null,
      receptor: {
        tipo: "6",
        ruc: "",
        razonsocial: "",
        direccion: ""
      },
      correo: "",
      listaCorreos: [],
      telefono: "",
      celular: "",
      tag1:"",
      tag2:"",
      listaTag:[],
      observaciones: "",
      info: "",
      updateClienteDatos: false,
      modalInsertUpdate: 1,
      nuevaDireccion: false,
      tipoDocumento: 6,
      documentosIdentidad: DocumentosIdentidadTerceros,
      isBusy: false,
      bloqueUbigeo: true,
      ubigeoPartida: "",
      placeholderUbigeoPartida: "Ubigeo Part.",
      prependUbigeoOrigen: "",
      departamentoSeleccionadoUbigeoOrigen: "00",
      listDepartamento: Departamentos,
      provOrigen: false,
      provOrigenCargando: false,
      provinciaSeleccionadaUbigeoOrigen: "",
      listProvinceOrigen: [],
      distOrigen: false,
      distOrigenCargando: false,
      distritoSeleccionadoUbigeoOrigen: "",
      listDistrictOrigen: [],
      direccionPartida: "",
      verifydirection: true,
      direccionTercero: "",
      infodireccion: "",
      idTercero: "",
      idDireccion: "",
      direccionTerceroDefecto: "",
      selected: true,
      cambiarDireccion: false,
      dataTercero: [],
      dataTerceroUpdate: {},
      direccionActual: {},
      rucValid: null,
      listaTerceros: [],
      listarec: true,
      norec: false,
      observacionesPro:'',
      observacionesNV:'',
      file1:null,
    };
  },
  mounted() {
    this.listTerceros();
    this.listTag()
  },
  computed: {
    stateCorreo() {
      let expreg = new RegExp(
        "^[a-zA-Z0-9-_.]{1,}@[a-zA-Z0-9-_]{1,}.[a-z]{2,3}(.[a-z]{2})?$"
      );
      if (!expreg.test(this.correo)) {
        return false;
      } else {
        return true;
      }
    },
    invalidFeedbackCorreo() {
      if (this.correo.length == 0) {
        return "Ingresa un correo válido";
      } else {
        return "";
      }
    },
    validFeedbackCorreo() {
      return this.stateCorreo === true ? "Perfecto" : "";
    }
  },
  watch: {
    "receptor.ruc": function() {
      if (this.receptor.ruc.length == 0) {
        (this.receptor.ruc = ""),
          (this.receptor.tipo = "6"),
          (this.receptor.razonSocial = ""),
          (this.receptor.direccion = ""),
          (this.listarec = false),
          (this.listaTerceros = []);
      }
    },
    tipoDocumento: function() {
      if (this.tipoDocumento == "0") {
        this.sindoc = true;
      } else {
        this.sindoc = false;
      }
    },
    nuevocliente: function() {
      if (!this.nuevocliente) {
        (this.dataTerceroUpdate = {}),
          (this.receptor.ruc = ""),
          (this.receptor.razonsocial = ""),
          (this.receptor.direccion = ""),
          (this.correo = ""),
          (this.telefono = ""),
          (this.celular = ""),
          (this.observaciones = ""),
          (this.listaCorreos = []);
      }
    },
    nuevaDireccion: function() {
      if (!this.nuevaDireccion) {
        this.listTerceros();
      } else {
        this.edicciondir = false;
      }
    },
    distritoSeleccionadoUbigeoOrigen: function() {
      (this.distOrigenCargando = false),
        (this.ubigeoPartida =
          this.departamentoSeleccionadoUbigeoOrigen +
          this.provinciaSeleccionadaUbigeoOrigen +
          this.distritoSeleccionadoUbigeoOrigen.codDistrito),
        (this.prependUbigeoOrigen = this.distritoSeleccionadoUbigeoOrigen.nombre),
        (this.bloqueUbigeoPartida = true);
    },
    provinciaSeleccionadaUbigeoOrigen: function() {
      (this.distOrigen = true),
        (this.distOrigenCargando = true),
        this.searchDistrictOrigen(this.distOrigenCargando, 1);
    },
    departamentoSeleccionadoUbigeoOrigen: function() {
      (this.provOrigen = true), this.searchProvinceOrigen(1);
    }
  },
  methods: {
    setValueDireccion: function(value) {
      (this.edicciondir = true),
        (this.direccionActual = value),
        (this.ubigeoPartida = value.ubigeo),
        (this.direccionTercero = value.direccion);
    },
    editDireccion: function() {
      this.editandodireccion = true;
      axios
        .post(process.env.VUE_APP_API_URL + "terceros/direcciones/actualizar", {
          token: this.$store.getters.userToken,
          id: this.direccionActual.idTercero,
          iddireccion: this.direccionActual.idDireccion,
          ubigeo: this.ubigeoPartida,
          direccion: this.direccionTercero
        })
        .then(
          response => (
            this.$snotify.success(response.data.msg, "Exito"),
            this.listDirection(),
            (this.ubigeoPartida = ""),
            (this.direccionTercero = ""),
            (this.edicciondir = false),
            (this.editandodireccion = false)
          )
        )
        .catch(error => {
          this.$snotify.error(error.response.data.msg, "Error"),
            (this.edicciondir = false),
            (this.editandodireccion = false);
        });
    },
    preDeleteDireccion: function(value) {
      this.$swal({
        title: "Eliminar Dirección",
        text: "Seguro de eliminar la direccion " + value.direccion + "???",
        icon: "error",
        buttons: true,
        dangerMode: true
      }).then(willDelete => {
        if (willDelete) {
          (this.direccionActual = value), this.deleteDireccion();
        } else {
          this.$snotify.error(error.response.data.msg, "Error");
        }
      });
    },
    deleteDireccion: function() {
      axios
        .post(process.env.VUE_APP_API_URL + "terceros/direcciones/eliminar", {
          token: this.$store.getters.userToken,
          id: this.direccionActual.idTercero,
          iddireccion: this.direccionActual.idDireccion
        })
        .then(
          response => (
            this.$snotify.success(response.data.msg, "Exito"),
            this.listDirection()
          )
        )
        .catch(error => {
          this.$snotify.error(error.response.data.msg, "Error");
        });
    },
    addCorreo: function() {
      // this.listaCorreos = []
      if (this.correo != "" && this.stateCorreo) {
        this.listaCorreos.push(this.correo), (this.correo = "");
      } else {
        this.$snotify.error("Debe ingresar un correo valido", "Error");
      }
    },
    removeCorreo: function(index) {
      this.listaCorreos.splice(index, 1);
    },
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    searchProvinceOrigen: function(ind) {
      let departamentoActual = "";
      if (ind == 1) {
        departamentoActual = this.departamentoSeleccionadoUbigeoOrigen;
        this.provOrigenCargando = true;
      } else if (ind == 2) {
        departamentoActual = this.departamentoSeleccionadoUbigeoOrigenTramo;
        this.provOrigenCargandoTramo = true;
      }
      axios
        .post(process.env.VUE_APP_API_URL + "ubigeo/provincia", {
          token: this.$store.getters.userToken,
          department: departamentoActual
        })
        .then(
          response => (
            (this.listProvinceOrigen = response.data),
            (this.provOrigenCargando = false),
            (this.provOrigenCargandoTramo = false)
          )
        )
        .catch(error => {});
    },
    // getTercero: function () {
    //     this.updateClienteDatos = true,
    //     axios
    //     .post(process.env.VUE_APP_API_URL + 'receptores/actualizar',{
    //         token: this.$store.getters.userToken,
    //         tipoRec: this.tipoDocumento,
    //         q: this.receptor.ruc
    //     })
    //     .then(response => (
    //         this.updateClienteDatos = false,
    //         this.receptor.razonSocial = response.data.razon_social,
    //         this.receptor.direccion = response.data.direccion_referencia,
    //         this.$snotify.success(response.data.msg, 'Éxito')
    //     ))
    //     .catch(error => (
    //         this.updateClienteDatos = false,
    //         this.$snotify.error('Error')
    //     ))
    // },
    getTercero: function() {
      this.cargandoreceptor = true;
      this.updateClienteDatos = true;
      if (this.receptor.ruc.length >= 3) {
        this.stateReceptorRuc(this.receptor.ruc, this.tipoDocumento);
        if (this.rucValid) {
          this.listarec = true;
          this.norec = false;
          axios
            .post(process.env.VUE_APP_API_URL + "receptores/lista", {
              token: this.$store.getters.userToken,
              tipoRec: this.tipoDocumento,
              q: this.receptor.ruc
            })
            .then(
              response => (
                (this.listaTerceros = response.data),
                (this.updateClienteDatos = false),
                (this.cargandoreceptor = false)
              )
            )
            .catch(
              error => (
                (this.cargandoreceptor = false),
                (this.updateClienteDatos = false),
                this.$snotify.error("Error")
              )
            );
        } else {
          (this.updateClienteDatos = false), (this.cargandoreceptor = false);
        }
      }
    },
    listTag: function() {
      axios
        .post(process.env.VUE_APP_API_URL + "tag/listar", {
          token: this.$store.getters.userToken,
          limit: "40",
          order: "desc"
        })
        .then(
          response => (
            (this.listaTag = response.data.data)
          )
        )
        .catch(error => (this.$snotify.error("Error")));
    },
    setReceiver: function(item) {
      (this.receptor.ruc = item.idReceptor),
        (this.receptor.tipo = item.tipo),
        (this.receptor.razonSocial = item.razonSocial),
        (this.receptor.direccion = item.direccionReferencia),
        (this.listarec = false),
        (this.listaTerceros = []);
    },
    stateReceptorRuc(value, tipo) {
      let expreg = new RegExp("\\s|<|>|[A-Za-z]|^[3-9]|^[0]");
      if (tipo == 6) {
        if (value.length == 0) {
          this.rucValid = false;
        } else if (expreg.test(value)) {
          this.$snotify.error("Ruc Inválido", "Error");
          this.rucValid = false;
        } else {
          this.rucValid = true;
        }
      } else {
        this.rucValid = true;
      }
    },
    addUpdateClient: function(value) {
        let observacionesDocumentos = [
         {
          doc: 'Proforma',
          obs: this.observacionesPro,
         },
         {
          doc: 'Nota de Venta',
          obs: this.observacionesNV,
         } 
       ]
      this.editclient = false;
      this.emitclient = false;
      let direccion = this.receptor.direccion;
      let domfiscal = this.receptor.direccion;
      let addupdate = "";
      let receptornumero = "";
      let tipodoc = "";
      if (value === 1) {
        (addupdate = "terceros/insertar"), (this.modalInsertUpdate = 1);
      } else if (value === 2) {
        (addupdate = "terceros/actualizar/1"), (this.modalInsertUpdate = 2);
      }
      receptornumero = this.receptor.ruc;
      if (this.tipoDocumento == "0") {
        (tipodoc = "0"), (receptornumero = "-");
      } else if (this.tipoDocumento == "10") {
        (tipodoc = "0"), (receptornumero = this.receptor.ruc);
      } else {
        (tipodoc = this.tipoDocumento), (receptornumero = this.receptor.ruc);
      }
      axios
        .post(process.env.VUE_APP_API_URL + addupdate, {
          token: this.$store.getters.userToken,
          id: this.idTercero,
          tipodocumento: tipodoc,
          documento: receptornumero,
          razonsocial: this.receptor.razonSocial,
          direccion: this.receptor.direccion,
          domfiscal: this.receptor.direccion,
          tipotercero: 1,
          emailenvio: this.listaCorreos,
          telefono: this.telefono,
          tag1: this.tag1,
          tag2: this.tag2,
          movil1: this.celular,
          observaciones: this.observaciones,
          obsDocs:observacionesDocumentos
        })
        .then(
          response => (
            (this.info = response.data),
            (this.editclient = true),
            (this.emitclient = true),
            (this.nuevocliente = false),
            this.listTerceros(),
            this.initModalCliente(),
            this.$snotify.success(response.data.msg, "Éxito")
          )
        )
        .catch(
          error => (
            (this.editclient = true),
            (this.emitclient = true),
            this.$snotify.error("Error")
          )
        );
    },
    initModalCliente: function() {
      (this.receptor.ruc = ""),
        (this.receptor.razonSocial = ""),
        (this.receptor.direccion = ""),
        (this.listaCorreos = []),
        (this.telefono = ""),
        (this.celular = ""),
        (this.observaciones = ""),
        (this.tipoDocumento = "6");
    },
    updateTerceros: function() {
      axios
        .post(process.env.VUE_APP_API_URL + "terceros/actualizar/1", {
          token: this.$store.getters.userToken,
          ruc: this.receptor.ruc,
          tipotercero: 1,
          emailenvio: this.correo,
          telefono: this.telefono,
          observaciones: this.observaciones
        })
        .then(
          response => (
            (this.info = response.data),
            this.$snotify.success(response.data.msg, "Éxito")
          )
        )
        .catch(error => this.$snotify.error("Error"));
    },
    searchClient: function() {
      // this.updateClienteDatos = true,
      axios
        .post(process.env.VUE_APP_API_URL + "receptores/actualizar", {
          token: this.$store.getters.userToken,
          ruc: this.rucCliente
        })
        .then(
          response => (
            (this.updateClienteDatos = false),
            (this.razon_social = response.data.response.razon_social),
            (this.domicilio_fiscal = response.data.response.domicilio_fiscal),
            this.$snotify.success(response.data.msg, "Éxito")
          )
        )
        .catch(
          error => (
            (this.updateClienteDatos = false),
            this.$snotify.error(
              "Por favor verifique el RUC que ingreso, de ser correcto comuniquese con el area técnica",
              "Error"
            )
          )
        );
    },
    tabindex: function(value) {
      if (value === 0) {
        this.changeView = 0;
      }
    },
    validClient: function() {
      if (this.tipoDocumento != 0) {
        if (
          this.receptor.ruc != "" &&
          this.receptor.razonSocial != "" &&
          this.receptor.direccion != ""
        ) {
          return true;
        } else {
          return false;
        }
      } else if (this.tipoDocumento == 0) {
        return true;
      }
    },
    validarDireccion: function() {
      if (this.direccionTercero != "") {
        return true;
      } else {
        return false;
      }
    },
    selectedDirection: function(value, index) {
      (this.idDireccion = value.idDireccion), (this.cambiarDireccion = true);
    },
    cambiarDireccionDefault: function() {
      this.isBusy = true;
      axios
        .post(
          process.env.VUE_APP_API_URL + "terceros/direcciones/predeterminar",
          {
            token: this.$store.getters.userToken,
            idtercero: this.idTercero,
            iddireccion: this.idDireccion
          }
        )
        .then(
          response => (
            (this.infodireccion = response.data.response.data),
            (this.isBusy = false),
            (this.cambiarDireccion = false)
          )
        )
        .catch(
          error => ((this.isBusy = false), (this.cambiarDireccion = false))
        );
    },
    newClient: function() {
      (this.modalInsertUpdate = 1),
        (this.nuevocliente = true),
        (this.update = false),
        (this.cargandoDataUpdate = true);
    },
    editClient: function(value) {
      // this.observacionesPro = value.obsDocs[0].obs;
      // this.observacionesNV = value.obsDocs[1].obs;
      (this.cargandoDataUpdate = false),
        (this.modalInsertUpdate = 2),
        (this.nuevocliente = true);
      axios
        .post(process.env.VUE_APP_API_URL + "terceros/buscar/1", {
          token: this.$store.getters.userToken,
          filtro: "id",
          p: value.idTercero
        })
        .then(
          response => (
            (this.dataTerceroUpdate = response.data.response),
            (this.idTercero = value.idTercero),
            this.responseEditCliente(this.dataTerceroUpdate),
            (this.update = true),
            (this.cargandoDataUpdate = true)
          )
        )
        .catch(error => {
          this.$snotify.error(error.response.data.msg, "Error");
        });
    },
    responseEditCliente: function(value) {
      this.receptor.ruc = value.documento;
      if (value.documento == "-" && value.tipoDocumento == "0") {
        this.tipoDocumento = value.tipoDocumento;
      } else if (value.documento != "-" && value.tipoDocumento == "0") {
        this.tipoDocumento = "10";
      } else if (value.tipoDocumento != "0") {
        this.tipoDocumento = value.tipoDocumento;
      }
      (this.receptor.razonSocial = value.razonSocial),
        (this.receptor.direccion = value.domFiscal),
        (this.correo = "");
      if (value.emailEnvio != null) {
        this.listaCorreos = value.emailEnvio;
      } else {
        this.listaCorreos = [];
      }
      (this.telefono = value.telefono),
        (this.celular = value.movil1),
        (this.observaciones = value.observaciones);
        this.tag1 = value.tag1,
        this.tag2 = value.tag2
    },
    listDirection: function(value, opc) {
      if (opc === 1) {
        this.idTercero = value.idTercero;
      } else if (opc === 2) {
        this.idTercero = value;
      }
      this.isBusy = true;
      this.nuevaDireccion = true;
      axios
        .post(process.env.VUE_APP_API_URL + "terceros/direcciones/listar", {
          token: this.$store.getters.userToken,
          id: this.idTercero
        })
        .then(
          response => (
            (this.directions = response.data.response.data),
            this.direccionDefecto(),
            (this.isBusy = false)
          )
        )
        .catch(error => ((this.isBusy2 = false), (this.isBusy = false)));
    },
    direccionDefecto: function() {
      if (this.directions.principal == 1) {
        this.selected = this.directions.idDireccion;
      }
    },
    addDirection: function() {
      this.verifydirection = false;
      this.isBusy = true;
      // this.nuevaDireccion = true
      axios
        .post(process.env.VUE_APP_API_URL + "terceros/direcciones/insertar", {
          token: this.$store.getters.userToken,
          id: this.idTercero,
          ubigeo: this.ubigeoPartida,
          direccion: this.direccionTercero
        })
        .then(
          response => (
            this.listDirection(this.idTercero, 2),
            (this.verifydirection = true),
            (this.ubigeoPartida = ""),
            (this.direccionTercero = "")
          )
        )
        .catch(
          error => (
            (this.isBusy2 = false),
            (this.verifydirection = true),
            (this.isBusy = true)
          )
        );
    },
    deleteClient: function(value) {
      swal({
        title: "Seguro de borrar a " + value.razonSocial,
        text: "Este proceso no se puede revertir!",
        icon: "warning",
        buttons: true,
        dangerMode: true
      }).then(willDelete => {
        if (willDelete) {
          this.deleteTercero(value), (this.isBusy2 = true);
        }
      });
    },
    deleteTercero: function(value) {
      this.isBusy2 = true;
      axios
        .post(process.env.VUE_APP_API_URL + "terceros/eliminar/1", {
          token: this.$store.getters.userToken,
          id: value.idTercero
        })
        .then(
          response => (
            this.$snotify.success(response.data.msg, "Éxito"),
            this.listTerceros()
          )
        )
        .catch(
          error => (
            (this.cargando = false),
            (this.isBusy2 = false),
            this.$snotify.error(error.response.data.msg, "Error")
          )
        );
    },
    addContact: function(value) {
      (this.changeView = 1),
        (this.dataCustomer = value),
        (this.customerSelected = value.idTercero);
    },
    listTerceros: function() {
      // this.cargando = true,
      this.isBusy2 = true;
      axios
        .post(process.env.VUE_APP_API_URL + "terceros/listar/1", {
          token: this.$store.getters.userToken,
          page: this.currentPage,
          // limit: this.limite,
          order: this.orden
        })
        .then(
          response => (
            (this.customers = response.data),
            (this.totalRows = this.customers.length),
            (this.total = this.totalRows),
            (this.desde = 1),
            (this.hasta = this.totalRows),
            (this.nuevocliente = false),
            (this.isBusy2 = false)
          )
        )
        .catch(error => ((this.nuevocliente = false), (this.isBusy2 = false)));
    },
    importarTerceros(){
      let formData = new FormData();
      formData.append("token", this.$store.getters.userToken);
      formData.append("excel", this.file1);
      axios
      .post(process.env.VUE_APP_API_URL + "terceros/importar",formData,
        {
          responseType: "blob",
          headers: {
          "Content-Type": "multipart/form-data"
          }
        })
      .then(response => {
        this.file1 = null,
        this.listTerceros(),
        this.$snotify.success("Documento importado exitosamente!", "Éxito")
        })
      .catch(error => {console.log(error)});  
    },
    eliminarFile(){
      this.file1 = null
    }
  }
};
</script>

<style>
.btnadddirection {
  border-radius: 15px;
  width: 30px;
  height: 30px;
}
.styleruc {
  margin-top: 5px;
  font-size: 12px;
  font-weight: bold;
  color: #008e97;
}
.marginleft {
  margin-left: 5px;
}
.lineaseparacion {
  margin-top: 5px;
  width: 100%;
  height: 2px;
  background-color: #ccc;
}
.centercorreo {
  margin-left: 16%;
  font-weight: bold;
  color: #636363;
}
.borrarcorreo {
  color: red;
}
.buttonaccion {
  padding-top: 1px;
  padding-bottom: 1px;
  padding-left: 6px;
  padding-right: 6px;
}
.buttoneditar {
  margin-left: 28px;
}
.stylerazonsocial {
  color: #3d3d3d;
}
.searcher-field {
  z-index: 1000;
  position: absolute;
  max-height: 400px !important;
  overflow-y: scroll;
  width: 500px;
}
.searcher-result {
  font-size: smaller;
  padding: 2px 0px 2px 0px;
  cursor: pointer;
}
.colorred {
  color: #12cd42;
}
</style>